export default "__VITE_ASSET__f8f5e93c__"